import $ from 'jquery';
import moment from 'moment/moment';
import urlRegexSafe from 'url-regex-safe';

import { VIDEO_TIMESTAMP_CLASS } from 'constants/comments';
import { splitTrailingPunctuation } from 'utilities/url';

import { HHMMSS_REGEX } from 'validate';

export const stripContent = medium => {
  const commentContent = replaceURLs(
    replaceVideoTimestamps(medium.value().trim())
  );

  return commentContent.replace(/<p>&nbsp;<\/p>/g, '');
};

const createAnchorLinkHtml = url => {
  const [trimmedUrl, trailing] = splitTrailingPunctuation(url);
  const hrefVal = /^www/.test(trimmedUrl) ? `//${trimmedUrl}` : trimmedUrl;

  return `<a target="_blank" class="external-link" href="${hrefVal}">${trimmedUrl}</a>${trailing}`;
};

export const replaceURLs = mediumContentHTML => {
  // first replace all video timestamps with their text contents so the regex
  // doesn't over-replace and nest timestamps
  const $strippedMediumContent = $('<div></div>').html(mediumContentHTML);

  $strippedMediumContent
    .find(`a:not(.${VIDEO_TIMESTAMP_CLASS})`)
    .replaceWith(function () {
      return $(this).text();
    });

  return $strippedMediumContent
    .html()
    .replace(urlRegexSafe({ strict: true }), createAnchorLinkHtml);
};

export const replaceVideoTimestamps = mediumContentHTML => {
  // first replace all video timestamps with their text contents so the regex
  // doesn't over-replace and nest timestamps
  const $strippedMediumContent = $('<div></div>').html(mediumContentHTML);

  $strippedMediumContent
    .find(`.${VIDEO_TIMESTAMP_CLASS}`)
    .replaceWith(function () {
      return $(this).text();
    });

  return $strippedMediumContent.html().replace(HHMMSS_REGEX, timestamp => {
    let momentTimestamp = timestamp;

    // we must add the HH component if it doesn't exist
    if (momentTimestamp.split(':').length === 2) {
      momentTimestamp = `00:${timestamp}`;
    }

    const numSeconds = moment.duration(momentTimestamp).asSeconds();

    return [
      `<a href="#" class="${VIDEO_TIMESTAMP_CLASS}" data-seconds="${numSeconds}">`,
      `${timestamp}</a>`,
    ].join('');
  });
};
